import Amenities from './src/Amenities';
export default Amenities;